import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer uppercase">Nordsol</div>`
})
export class AppFooter {}
